import RegularProduct from 'components/ProductPage/Type/RegularProduct/RegularProduct';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { showHighlightLayerWithPDP } from 'viewModel/selectors/testTarget/showHighlightLayerWithPDP';
import { isShowSMNEnabledSelector } from 'viewModel/selectors/testTarget/showSMNSelector';
import { featuresAIBeautyChatSelector } from 'ai/selectors/testTarget/featuresAIBeautyChatSelector';
import { showAddDropDownReviewSectionSelector } from 'viewModel/selectors/testTarget/showAddDropDownReviewSectionSelector';
import { showAtbCarouselsPDPSelector } from 'viewModel/selectors/testTarget/showAtbCarouselsPDPSelector';
import { showReorderPageSectionPdpSelector } from 'viewModel/selectors/testTarget/showReorderPageSectionPdpSelector';
import { showSocialProofPDPSelector } from 'viewModel/selectors/testTarget/showSocialProofPDPSelector';
import { showSmnCaPpageCarouselSelector } from 'viewModel/selectors/testTarget/showSmnCaPpageCarouselSelector';
import { showSmnCaPpageBannerSelector } from 'viewModel/selectors/testTarget/showSmnCaPpageBannerSelector';
import { showIncreaseATBButtonOnPdpSelector } from 'viewModel/selectors/testTarget/showIncreaseATBButtonOnPdpSelector';
import { showProductDisclosuresSelector } from 'viewModel/selectors/testTarget/showProductDisclosuresSelector';
import { showStickyNavBarPdpSelector } from 'viewModel/selectors/testTarget/showStickyNavBarPdpSelector';
import { showPDPTopOfPageRedesignSelector } from 'viewModel/selectors/testTarget/showPDPTopOfPageRedesignSelector';
import { showDiscountedPriceWithCodeSelector } from 'viewModel/selectors/testTarget/showDiscountedPriceWithCodeSelector';

const fields = createStructuredSelector({
    highlightLayerWithPDP: showHighlightLayerWithPDP,
    featuresAIBeautyChat: featuresAIBeautyChatSelector,
    showSMNEnabled: isShowSMNEnabledSelector,
    showAddDropDownReviewSection: showAddDropDownReviewSectionSelector,
    isCarouselsATBEnabled: showAtbCarouselsPDPSelector,
    reorderPageSectionPdp: showReorderPageSectionPdpSelector,
    showSocialProofPDP: showSocialProofPDPSelector,
    showSmnCaPpageCarousel: showSmnCaPpageCarouselSelector,
    showSmnCaPpageBanner: showSmnCaPpageBannerSelector,
    increaseATBButtonOnPdp: showIncreaseATBButtonOnPdpSelector,
    showProductDisclosures: showProductDisclosuresSelector,
    stickyNavBarPdp: showStickyNavBarPdpSelector,
    showPDPTopOfPageRedesign: showPDPTopOfPageRedesignSelector,
    showDiscountedPriceWithCode: showDiscountedPriceWithCodeSelector
});

const withHighlightValueVisibilityProps = connect(fields);

export default withHighlightValueVisibilityProps(RegularProduct);
